import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { RCumLaudeAccountX } from '../interne-accounts-toevoegen-dialog/interne-accounts-toevoegen-dialog.component';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { DialogHeaderComponent, BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-edit-account-dialog',
	templateUrl: './edit-account-dialog.component.html',
	styleUrls: ['./edit-account-dialog.component.scss'],
	host: {
		'(window:keyup.Enter)': 'onDialogClick()',
	},
	imports: [BaseDialogComponent, DialogHeaderComponent, FormsModule, ButtonComponent, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAccountDialogComponent {
	dialogData = inject<DialogData>(DIALOG_DATA);
	protected dialogRef = inject<DialogRef<RCumLaudeAccountX>>(DialogRef);

	model: RCumLaudeAccountX;

	constructor() {
		this.model = { ...this.dialogData.model }; // shallow copy is harmless here
	}

	@ViewChild('naam')
	naamModel!: NgModel;

	@ViewChild('email')
	emailModel!: NgModel;

	onDialogClick() {
		if (!this.naamModel.invalid && !this.emailModel.invalid) this.dialogRef.close(this.model);
	}

	isShowFeedback(field: NgModel): boolean {
		return Boolean(field.invalid && field.touched);
	}
}

interface DialogData {
	caption: string;
	action: string;
	model: RCumLaudeAccountX;
}
